import { useMutation, useQuery, useQueryClient } from 'react-query';

import { GetNotificationsQ } from './dto';

import * as API from './api';

interface HandleReturn {
  onError?: () => void;
  onSuccess?: () => void;
}

interface CustomMutation<Query, Response> {
  key: string;
  request: (params: Query) => Promise<Response>;
  handleReturn?: HandleReturn;
  queriesToInvalidate?: string[];
}

function useCustomMutation<Query, Response>({
  handleReturn,
  key,
  request,
  queriesToInvalidate,
}: CustomMutation<Query, Response>) {
  const queryClient = useQueryClient();

  return useMutation([key], (params: Query) => request(params), {
    onSuccess: () => {
      if (queriesToInvalidate) {
        queriesToInvalidate.map(query => queryClient.invalidateQueries(query));
      }
      if (handleReturn?.onSuccess) handleReturn?.onSuccess();
    },
    onError: () => {
      if (handleReturn?.onError) handleReturn?.onError();
    },
  });
}

export function useGetNotifications(params: GetNotificationsQ) {
  return useQuery(['getNotifications'], () => API.getNotifications(params), {
    cacheTime: 0,
    enabled: !!params?.userId,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 3000,
  });
}
export function useReadNotification(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'readNotification',
    request: API.readNotification,
    handleReturn,
    queriesToInvalidate: ['getNotifications'],
  });
}

export function useReadNotifications(handleReturn?: HandleReturn) {
  return useCustomMutation({
    key: 'readNotifications',
    request: API.readNotifications,
    handleReturn,
    queriesToInvalidate: ['getNotifications'],
  });
}
